/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_CollapseInputs */

const cs_ebr_diff_collapse = /** @type {(inputs: Ebr_Diff_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sbalit`)
};

const en_ebr_diff_collapse = /** @type {(inputs: Ebr_Diff_CollapseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collapse`)
};

/**
* | output |
* | --- |
* | "Collapse" |
*
* @param {Ebr_Diff_CollapseInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_collapse = /** @type {((inputs?: Ebr_Diff_CollapseInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_CollapseInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_collapse(inputs)
	return cs_ebr_diff_collapse(inputs)
});